module.exports = __webpack_public_path__ + "static/media/gallery21.85720d1d.png";